import React from 'react'
import '../../App.css'
import './About.css'
// import '../Mentor/Mentors.css'
import web from '../images/Mahendra.png'
import Fade from 'react-reveal/Fade'
import Slide from 'react-reveal/Slide'
import Zoom from 'react-reveal'

import web1 from '../images/mentor/mentor1.png'
import web2 from '../images/mentor/mentor2.png'
import web3 from '../images/mentor/mentor3.png'
import web4 from '../images/mentor/mentor4.png'
import web5 from '../images/mentor/mentor5.png'
import web6 from '../images/mentor/mentor6.png'
import web7 from '../images/mentor/mentor7.png'
import web8 from '../images/mentor/mentor8.png'
import web9 from '../images/mentor/nomentor.png'
import TseringNawangTamang from '../images/mentor/TseringNawangTamang.png'
import SitaKC from '../images/mentor/SitaKC.png'
import RakshaKhadka from '../images/mentor/RakshaKhadka.png'
import KarunaPandey from '../images/mentor/KarunaPandey.png'
import SushmaKhatri from '../images/mentor/SusmaKhatri.png'

export const About = ()=> {
    return (
        <>
            <Slide up>
                <section className="container-fluid about_wrapper">
                </section>
            </Slide>
            <section className="about_body">
                <div className="container">
                    <Fade right>

                        <div className="mission w-75 m-auto ">

                            <h2>Our Mission</h2>
                            <hr className="thick-border mb-5" />
                            <p className='mt-3'>Established in February 2020, Lacuna Venture has come a long way from its modest beginnings in Kathmandu, Nepal. Our passion for the Startups & Entrepreneurship Culture drove us to conduct extensive research so that Lacuna Venture could provide you with the thrilling entrepreneurial journey.</p>
                            <p className='mt-3'> “Our unique approach combines practical skills required in effective teamwork with innovative thinking as we learn from other successful entrepreneurs throughout the world. We strive toward engaging entrepreneurs by creating collaborative entrepreneurial opportunities which are rooted into real life experiences so they can engage at deeper levels inside their mind.”</p>
                            <ul >
                                <li><a href="">Cutting edge customer development tracking knowledge and instrument</a></li>
                                <li><a href="">Cutting edge customer development tracking knowledge and instrument</a></li>
                                <li><a href="">Cutting edge customer development tracking knowledge and instrument</a></li>
                            </ul>
                        </div>
                    </Fade>
                    <section className="team">
                        <h2>Our Team</h2>
                        <hr className="thick-border mb-5" />


                        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 5"></button>
                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="6" aria-label="Slide 6"></button>
                            </div>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <div className="row mt-3">
                                        <div className="col-sm-4">
                                            <div className="mentor2">
                                                <img src={web1} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Mahendra Gautam</h5>
                                                <h6 className='text-center my-2 text-muted'>CEO</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="mentor2">
                                                <img src={web2} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sudip Acharya</h5>
                                                <h6 className='text-center my-2 text-muted'>COO</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web6} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Niman Shakya</h5>
                                                <h6 className='text-center my-2 text-muted'>CDO</h6>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web5} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Kiran Thapa Magar</h5>
                                                <h6 className='text-center my-2 text-muted'>CMO</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Jayant Jha</h5>
                                                <h6 className='text-center my-2 text-muted'>Chief Sales Manager</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Shekher Adhikari</h5>
                                                <h6 className='text-center my-2 text-muted'>CTO</h6>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">

                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web8} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sukriti Subedi</h5>
                                                <h6 className='text-center my-2 text-muted'>QA Engineer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={TseringNawangTamang} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'> Tsering Nawang Tamang</h5>
                                                <h6 className='text-center my-2 text-muted'>Event Manager</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Series Chikanbanjar</h5>
                                                <h6 className='text-center my-2 text-muted'>Tech Lead</h6>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={SitaKC} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sita KC</h5>
                                                <h6 className='text-center my-2 text-muted'>Graphic Designer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Amrit Gurung</h5>
                                                <h6 className='text-center my-2 text-muted'>Graphic Designer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Sikha Neupane</h5>
                                                <h6 className='text-center my-2 text-muted'>Content Writer</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web3} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Gagan Khanal</h5>
                                                <h6 className='text-center my-2 text-muted'>Software Developer</h6>
                                            </div>
                                        </div>
                                        <div className=" col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web4} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Bikesh chaudhari</h5>
                                                <h6 className='text-center my-2 text-muted'>Software Developer</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={RakshaKhadka} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Raksha Khadka</h5>
                                                <h6 className='text-center my-2 text-muted'>Software Developer</h6>
                                            </div>
                                        </div>
                                     
                                       

                                    </div>
                                </div>
                                
                                <div className="carousel-item">
                                    <div className="row mt-3">
                                    <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Amit Jung Himali</h5>
                                                <h6 className='text-center my-2 text-muted'>Graphic Designer</h6>
                                            </div>
                                        </div>

                                        <div className=" col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={KarunaPandey} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Karuna Pandey</h5>
                                                <h6 className='text-center my-2 text-muted'>Intern</h6>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={SushmaKhatri} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Susma Khatri</h5>
                                                <h6 className='text-center my-2 text-muted'>Intern</h6>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <div className="row mt-3">
                                    <div className=" col-sm-4 ">
                                            <div className="mentor2">
                                                <img src={web9} alt="" />
                                            </div>
                                            <div className=" test_info2">
                                                <h5 className='text-center my-2'>Dristy Aryal</h5>
                                                <h6 className='text-center my-2 text-muted'>Intern</h6>
                                            </div>
                                        </div>
                                      
                                     
                                       

                                    </div>
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>

                    </section>
                </div>

            </section >
            <div className="container m-auto w-75 pb-4">
                <Zoom>

                   <h2 className='text-center'>How we work?</h2>
                </Zoom>
                <p>
                    We are a full-service marketing and advertising agency, fashion designing, e-commerce services, digital marketing, and technology ecosystem. Our team specializes in supporting customers across all industry sectors. <b> Our team helps clients specify, plan, execute, manage, and optimize technology and sustainable business ecosystems.  We are passionate in delivering business outcomes and having a positive business impact,  and the way we collaborate with clients reflects this.</b>  We work closely with our clients to understand their individual needs in order to help them achieve their design goals. We also work to help them create the perfect company profile, every time. A key to any good relationship, communication is an essential way to build customer relationships. <b> The Lacuna Venture family promotes and listens to our customers, so we confront what our clients need, and show them that we have solutions to their problem.</b>

                </p>
                <p>
                    We are a team that draws upon our years of experience designing for high-end clients. Our main focus is on brand and visual identity but we also bring a unique mix of design thinking, illustration, and computer illustration together to operate sustainable business. <b> We are the ideal solution for your next sustainable business model with an affordable design portfolio to build a strong company profile brand.</b> From this humble beginning, we have grown into a business that brings the best services to the world. We always highly appreciate our customers for the feedback and the opportunities. Most important, we raise the bar by delivering the highest quality of services faster than anticipated.
                </p>
            </div>

     



            
        </>

    )
}
